import { BsUtilReceivers } from "../../dependencies";
import { SendMessageType } from "../../types";
import { restrictedSportIds } from "../../constants";
import { storeItems } from "../../helpers";
export function addQuickBetslipId(config) {
    let messageType = config.messageType;
    switch (config.selectionsCount) {
        case 0:
            setMessage(messageType, config.messageCache, config.items);
            break;
        case 1:
            if (messageType === SendMessageType.Add) {
                messageType = SendMessageType.Clear;
            }
            setMessage(messageType, config.messageCache, config.items);
            break;
    }
}
function setMessage(messageType, messageCache, items) {
    if (!isSportRestricted(items, restrictedSportIds)) {
        messageCache[messageType].receiverIds.push(BsUtilReceivers.QuickBetSlip);
        storeItems(messageType, messageCache, items);
    }
}
function isSportRestricted(items, restrictedSportIds) {
    return items.some(i => {
        return i.sportId && restrictedSportIds.indexOf(i.sportId) >= 0;
    });
}
//# sourceMappingURL=addQuickBetslipId.js.map